import React, { useEffect, useState } from "react";
import axios from "axios";
import { FiSearch, FiPieChart } from "react-icons/fi";
import { Link } from "react-router-dom";
import $ from "jquery";

import "../css/landing.css";

import book from "../assets/book.svg";
import baby from "../assets/baby.svg";
import deathFly from "../assets/death-fly.svg";
import reading from "../assets/reading.svg";
import flyingBook from "../assets/flying-book.svg";
import bible from "../assets/bible.svg";

import HeaderBar from "../components/headerBar";

export default function Landing() {
    const [ bookName, setBookName ] = useState("");
    const [ bookNamePreview, setPreviewName ] = useState("Incentive um mundo melhor.");

    const [ bibleVerses, setVerses ] = useState("");
    const [ randomVerse, setRandomVerse ] = useState("");
    const [ verseAuthorSchema, setAuthorSchema ] = useState("");

    function typpingBookName(key) {
        setBookName(key.target.value);
        setPreviewName(key.target.value + "?");
        document.getElementById("bookNamePreview").innerText = `${bookName}?`

        var bookNameInput = document.getElementById("bookNameInput").value;

        document.getElementById("bookSearching").href = `/procurar/livros/paid/${bookNameInput}`;
    }

    function submitSearching(event) {
        event.preventDefault();

        var bookNameInput = document.getElementById("bookNameInput").value;

        window.location.href = `/procurar/livros/paid/${bookNameInput}`
    }

    useEffect(() => {
        axios.get("https://cloudify-backend.herokuapp.com/libraries/list")
        .then(lib => {
            var libData = lib.data;
            var libs = libData.libraries;

            var handler = document.getElementById("libGenerator");

            libs.forEach(lib => {
                axios.get(`https://cloudify-backend.herokuapp.com/users/get/byid/${lib.ownerId}`)
                .then(usr => {

                    console.log(usr.data);

                    var count = 30;
                    var title = lib.libraryName.slice(0, count) + (lib.libraryName.length > count ? "..." : "");

                    $(handler).append(` <a href="/community/libraries/${lib.libraryId}" id="libLink" > <div id="generatedLib"> <div id="centered"> <div id="libUserPic"> <img id="libUserPfp" src="${usr.data.userInfo.profilePicture}" /> </div> </div> <div id="centered"> <h1 id="libGenTitle">${title}</h1> </div> <div id="centered"> <h2>de ${usr.data.userInfo.socialname}</h2> </div> </div> </a> `)
                })
            })
        })
    }, [])

    function tryingNewBook() {
        window.location.href = `/procurar/livros/paid/Harry Potter`
    }

    return(
        <div className="app">
            <div id="pageFirstSection">
                <HeaderBar />

                <div id="pageTitleHandler">
                    <div className="centered" id="pageTitleFirst">
                        <h1>Comece a ler,</h1>
                    </div>
                    <div className="centered" id="pageTitleSecond">
                        <h1 id="bookNamePreview">{bookNamePreview}</h1>
                    </div>
                </div>

                <div className="centered">
                    <div id="searchDiv">

                        <form onSubmit={submitSearching} >

                            <input placeholder="Pesquise algo" onChange={typpingBookName} value={bookName} id="bookNameInput" />

                        </form>

                        <a id="bookSearching">
                            <button id="searchConfirmButton">
                                <FiSearch />
                            </button>
                        </a>
                    </div>
                </div>

                <div className="centered">
                    <button id="tryReading" onClick={ tryingNewBook } >Experimentar</button>
                </div>

                <div className="centered">
                    <img src={book} id="book-ilustration" />
                </div>
            </div>
            <div id="peopleDataHandlerDIV">
                <div className="centered">
                    <h1>BIBLIOTECAS QUE VOCÊ PODE GOSTAR</h1>
                </div>

                <div className="centered">
                    <div id="libGenerator" />
                </div>
            </div>
        </div>
    )
}